export default __webpack_public_path__ + "media/images/images/portfolio/portfolio-2-e29a77265f71bf7e0d1c5c4c7fd51036.jpg";